/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios";
import storage from "../util/storage";
//  import store from '../store/store';
//  import { Toast } from 'vant';

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
//  const tip = msg => {
//      Toast({
//          message: msg,
//          duration: 1000,
//          forbidClick: true
//      });
//  }

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 1105:
      storage.remove("token");
      storage.remove("userCache");

      break;
    // 401: 未登录状态，跳转登录页
    case 401:
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      //  tip('登录过期，请重新登录');
      //  localStorage.removeItem('token');
      //  store.commit('loginSuccess', null);
      //  setTimeout(() => {
      //      toLogin();
      //  }, 1000);
      break;
    // 404请求不存在
    case 404:
      //  tip('请求的资源不存在');
      break;
    default:
      window.console.log(other);
  }
};
console.log(window.configUrl.baseURL);
// 创建axios实例
var instance = axios.create({
  baseURL: window.configUrl.baseURL,
  timeout: 1000 * 60
});
// 设置post请求头
instance.defaults.headers.post["Content-Type"] =
  "application/json";

// 实例创建之后修改配置
// instance.defaults.headers.common["x-currency-type"] = "MOP";
// instance.defaults.headers.common["x-device-os"] = "pc";
// instance.defaults.headers.common["x-channel"] = "FM_PC-8";

//  window.console.log("========="+ storage.get('lang'));
//   storage.get('lang') == 's'? instance.defaults.headers.common['locale'] = 'cn'
//                                 :instance.defaults.headers.common['locale'] = 'taiwan';

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {

    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    //  const token = store.state.token;
    //  token && (config.headers.Authorization = token);

    var lang =  window.localStorage.getItem('lang') ;
      if(lang.indexOf("en")!=-1){
        config.headers["LANG"] = 'EN';
      }else if(lang.indexOf("zh")!=-1){
        config.headers["LANG"] = "ZH";
      }else if(lang.indexOf("po")!=-1){
        config.headers["LANG"]  = 'PO';
      }else{
        config.headers["LANG"] = "MO";
      }
    // storage.get("currencytype") != null
    //   ? (config.headers.common["x-currency-type"] = storage.get("currencytype"))
    //   : (config.headers.common["x-currency-type"] = "MOP");

    // config.headers.common["x-auth-token"] = storage.get("token");

    // if (config.url.indexOf("upload/oss") != -1) {
    //   config.headers.post["Content-Type"] = "multipart/form-data";
    // } else {
    //   config.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
    // }

    return config;
  },
  error => Promise.error(error)
);

// 响应拦截器
instance.interceptors.response.use(
  res => {
    if (res.data.code == 200) {
      return Promise.resolve(res);
    } else {
      errorHandle(res.data.code, res.data.msg);
      return Promise.resolve(res);
    }
  },
  error => {
    return Promise.reject(error.message);
  }
);

export default instance;
